<div class='question th-question-sides' [formGroup]='thirdPartyForm'>
	<div class='th-question-left-side'>
		<div class='question-title'>{{question.title}}</div>
		<div class='question-text'>{{question.question}}</div>
	</div>
	<div class='th-question-right-side'>
		<div class='question-control'>
			<mat-radio-group formControlName="question_{{questionKey}}" aria-label="Select an option" (change)="checkAndSetRequired(questionKey, questionIndex)">
				<mat-radio-button value="1" i18n='@@optionYes'>Yes</mat-radio-button>
				<mat-radio-button value="2" i18n='@@optionNo'>No</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>

	<!-- Check for extra questions -->
	<div class='question-extra' *ngIf='thirdPartyForm.controls["question_" + questionKey].value === "1"'>
		<app-sub-question *ngIf='question.extra_1_type !== 0' [mainQuestionKey]='questionKey' [mainQuestionIndex]='questionIndex' [subQuestion]='1'></app-sub-question>
		<app-sub-question *ngIf='question.extra_2_type !== 0' [mainQuestionKey]='questionKey' [mainQuestionIndex]='questionIndex' [subQuestion]='2' ></app-sub-question>
	</div>
</div>
